import { gsap } from 'gsap'

export default {
  name: 'default-transition',
  leave(data) {
    return gsap.to(data.current.container, {
      duration: 0.7,
      autoAlpha: 0,
      ease: 'linear',
    })
  },
  enter(data) {
    document.documentElement.scrollTop = 0

    return gsap.fromTo(data.next.container, {
      autoAlpha: 0,
    }, {
      duration: 0.7,
      autoAlpha: 1,
      ease: 'linear',
    })
  },

}
